import _ from 'lodash'

export function fixPath(path: string): string {
  return '/' + _.trim(path.replace(/([^:]\/)\/+/g, '$1'), '/')
}
